import { render, staticRenderFns } from "./ChatsList.vue?vue&type=template&id=5ef70721&"
import script from "./ChatsList.vue?vue&type=script&lang=js&"
export * from "./ChatsList.vue?vue&type=script&lang=js&"
import style0 from "./ChatsList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports